module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "page-footer"
  }, [_c('nav', [_vm._l((_vm.portfolio), function(item, key, i) {
    return [_c('a', {
      key: item.title,
      attrs: {
        "href": '/portfolio/' + item.id
      }
    }, [_vm._v("\n      " + _vm._s(item.title) + "\n    ")]), _vm._v(" "), (i != _vm.length) ? _c('span', [_vm._v("/")]) : _vm._e()]
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Copyright © " + _vm._s(_vm.year) + " TaiDesign")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e85a663","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/footer.vue
// module id = 153
// module chunks = 0